import { getMarginBottomClass } from '@piggybank/core';
import { DoorHanger } from '@piggybank/form';
import T from 'prop-types';
import React from 'react';
import { MarkdownTranslation } from './Markdown';
import { Translation, TranslationScope } from './context';

export const DynamicFormMoreInfo = ({ formValues = {}, path }) => (
  <TranslationScope path={path}>
    <Translation path="moreInfo">
      {moreInfo =>
        moreInfo.heading ? (
          <>
            <div className={getMarginBottomClass(2)} />
            <DoorHanger title={moreInfo.heading}>
              <MarkdownTranslation
                formValues={formValues}
                noBottomMargin={true}
                path="moreInfo"
              />
            </DoorHanger>
          </>
        ) : (
          <>
            <div className={getMarginBottomClass(5)} />
            <MarkdownTranslation
              formValues={formValues}
              marginBottom={4}
              path="moreInfo"
            />
          </>
        )
      }
    </Translation>
  </TranslationScope>
);

DynamicFormMoreInfo.propTypes = {
  formValues: T.object,
  path: T.array,
};
